<script setup lang="ts">
export interface Props {
  value: number
  duration?: number
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
  duration: 1000,
})
const displayValue = ref<number>(0)

const startAnimation = () => {
  const startValue = 0
  const endValue = props.value

  const rangeValue = endValue - startValue
  let currentValue = startValue
  const increment = endValue > startValue ? 1 : -1
  const stepTime = Math.abs(Math.floor(props.duration / rangeValue))
  const timer = setInterval(() => {
    currentValue += increment
    displayValue.value = currentValue
    if (currentValue === endValue) {
      clearInterval(timer)
    }
  }, stepTime)
  return () => clearInterval(timer)
}
const isVisible = ref(true)
const animatedCounter = ref<HTMLElement>()
onMounted(() => {
  const options = {
    rootNode: document.body,
    rootMargin: '0px 0px 50px 0px',
    threshold: 1,
  }
  const observer = new IntersectionObserver((entries) => {
    const [{ isIntersecting, intersectionRatio, target }] = entries
    if (isIntersecting && intersectionRatio > 0) {
      startAnimation()
      observer.unobserve(target)
    }
    isVisible.value = isIntersecting
  }, options)

  animatedCounter.value && observer.observe(animatedCounter.value)
})
</script>

<template>
  <span ref="animatedCounter" class="animated-counter">{{ displayValue }}</span>
</template>
